import http from '~/http/services/pos';
import { ApiResponse } from '../../../types/Api';
import {
  CashierTransaction,
  CashierTransactionItem,
} from '../../../types/CashierTransaction';

type CreateCashierTransactionResponse = ApiResponse<null>;

type CashierTransactionList = ApiResponse<CashierTransactionItem[]>;

export const createCashierTransaction = (body: CashierTransaction) => {
  return http.post<CreateCashierTransactionResponse>(
    '/api/v1/cashier/transaction',
    body
  );
};

export const getCashierTransaction = () => {
  return http.get<CashierTransactionList>('/api/v1/cashier/transaction');
};
